import { OrderedItemStyled } from '@OnArk/styles/OrderedList.styled';

import React, { FC, ReactElement } from 'react';

import { useOrderableContext } from './context';
import { MoveButton } from './moveButtons';

interface Props<
  Item extends { id: string; [key: string]: any },
  ItemProps extends Record<string, any> = Record<string, any>,
> {
  InsertButton: FC<
    React.PropsWithChildren<{
      insertAt: number;
      top?: boolean;
      bottom?: boolean;
      label?: string;
      as?: any;
    }>
  >;
  ItemRender: FC<
    {
      item: Item;
      idx: number;
    } & ItemProps
  >;
  wrapperProps?: Record<string, any>;
  noInsertButtons?: boolean;
  freeze?: boolean;
  light?: boolean;
  hideBottomButton?: boolean;
  itemProps?: ItemProps;
}

function OrderedList<
  Item extends { id: string; [key: string]: any },
  ItemProps extends Record<string, any> = Record<string, any>,
>({
  InsertButton,
  ItemRender,
  freeze,
  hideBottomButton,
  itemProps = {} as ItemProps,
  light,
  noInsertButtons,
  wrapperProps = {},
}: Props<Item, ItemProps>): ReactElement {
  const { items } = useOrderableContext<Item>();

  return (
    <>
      {items.map((item, idx) => (
        <OrderedItemStyled key={item.id} light={light} {...wrapperProps}>
          {!noInsertButtons && idx === 0 && <InsertButton top insertAt={idx} />}
          {/* createElement (not JSX) to avoid React 19's LibraryManagedAttributes
              strictness on a generic component rendered inside a generic fn. */}
          {React.createElement(ItemRender, { idx, item, ...itemProps })}
          {!freeze && <MoveButton idx={idx} />}
          {!noInsertButtons &&
            (!hideBottomButton || idx !== items.length - 1) && (
              <InsertButton bottom insertAt={idx + 1} />
            )}
        </OrderedItemStyled>
      ))}
    </>
  );
}

export default OrderedList;
export { OrderableListContext, useOrderableContext } from './context';
